import {z as zod} from "zod";

export type OttopilotGeographicNodesWorkspaceCapabilityConfiguration = Record<string, never>;

export const ottopilotGeographicNodesWorkspaceCapabilityConfigurationValidator: zod.ZodType<OttopilotGeographicNodesWorkspaceCapabilityConfiguration> = zod.strictObject({});
